<template>
  <div class="download">
    <img class="logo_img" :src="img.motortime_logo">
    <div class="title">汽车时间</div>
    <div class="content" v-if="isiOS">4.9分 518万次下载 26.2 MB</div>
    <div class="content" v-else>4.9分 518万次下载 26.7 MB</div>
    <!-- http://itunes.apple.com/us/app/id1084608468 -->
    <a class="btn" id="to_appstore" href="https://apps.apple.com/cn/app/%E6%B1%BD%E8%BD%A6%E6%97%B6%E9%97%B4/id1084608468"></a>
    <div class="btn" v-if="isiOS" @click="openDownload">去App Store下载</div>
    <div class="btn" v-else @click="download">立即下载</div>
    <div class="mask" v-if="isWechat"></div>
    <div class="mask_content" v-if="isWechat">
      <div style="text-align: left;font-size: 14px;">点击右上角按钮，然后在弹出的菜单中，点击在浏览器中打开，即可安装</div>
      <img class="right_top_arrow" :src="img.right_top_arrow">
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { Dialog } from "vant";
  import content from '../../api/content';
  export default {
    data () {
      return {
        isAndroid:false,
        isiOS:false,
        isWechat:false,
        updateStatus:'',
        updateUrl:'',
        updateText:'',
        img:{
          subaru_logo:require('../../assets/img/subaruf.png'),
          lexus_logo:require('../../assets/img/lexus.png'),
          motortime_logo:require('../../assets/img/motortimelogo.png'),
          right_top_arrow:require('../../assets/img/right_top_arrow.png'),
        },
      }
    },
    
    created () {
      this.getNewVersion()
      this.$store.commit('param/show', false)
      let source = this.$route.params.source
      var u = navigator.userAgent, app = navigator.appVersion;
      var ua = window.navigator.userAgent.toLowerCase();
      this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; 
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if(ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_'){
        this.isWechat=true
      }else{
        if(this.isiOS){
          Dialog.confirm({
            message:
            '即将打开App Store，下载汽车时间',
            confirmButtonColor:'#576B95'
          })
          .then(() => {
            var obj=document.getElementById('to_appstore')
            obj.click()
          })
          .catch(() => {
          });
        }else{
          var that=this
          window.location = 'motortime://pages/index/index'; 
          window.setTimeout(function() {
            window.location = that.updateUrl?that.updateUrl:'https://pic.motortime.com/app/MOTORTIME/motortime.apk'; 
          }, 1000);
        }
      }
    },
    methods: {
      getNewVersion(){
        content.getNewVersion({
          source: 7,
          version: 1.0
        }).then(res => {
          if(res.data.state == 1) {
            console.log(res)
            this.updateStatus = res.data.data.status
            this.updateUrl = res.data.data.url
            this.updateText = res.data.data.content
          }
        })
      },
      openDownload(){
       Dialog.confirm({
        message:
        '即将打开App Store，下载汽车时间',
        confirmButtonColor:'#576B95'
      })
       .then(() => {
        var obj=document.getElementById('to_appstore')
        obj.click()
      })
       .catch(() => {
       });
     },
     download(){
      var that=this
      window.location = 'motortime://pages/index/index'; 
      window.setTimeout(function() {
        window.location = that.updateUrl?that.updateUrl:'https://pic.motortime.com/app/MOTORTIME/motortime.apk'; 
      }, 500);
    // window.location.href='https://pic.motortime.com/app/MOTORTIME/motortime.apk'
  },
},
components: {
  [Dialog.name]: Dialog
}
};
</script>

<style lang="scss">
  .download {
    padding: 10px;
    text-align: center;
    .logo_img{
      width: 60px;
      height: 60px;
      margin-top: 35%;
    }
    .title{
      font-size: 18px;
      font-weight: bold;
      margin-top: 10px;
    }
    .content{
      font-size: 12px;
      margin-top: 10px;
    }
    .btn{
      color: #ffffff;
      font-size: 12px;
      margin-top: 50px;
      background-color: #12b7f5;
      padding: 15px 0;
      border-radius:3px;
      margin: 80px 15%;

    }
    .mask{
      position:fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom:0;
      background-color:rgba(0,0,0,.7);
      z-index: 999;
    }
    .mask_content{
      color: #ffffff;
      position:fixed;
      top: 15px;
      left: 15px;
      right: 35px;
      z-index: 1000;
      display: flex;
      align-items:flex-start;
    }
    .right_top_arrow{
      width: 40px;
      height: 40px;
    }
  }
</style>
